const DEFAULT_BFF_URL = import.meta.env.DEFAULT_BFF_URL;

const {
  VITE_BASE_HOST,
  VITE_BASE_URL_V1,
  VITE_BASE_ENVIRONMENT,
  VITE_GTM_ID: GTM_ID,
  VITE_SCOTIABANK_URL: SCOTIABANK_URL,
  VITE_MS_PAYMENTS_METHODS_BASE_URL,
  VITE_BFF_BROWSER_BASE_URL
} = import.meta.env;

const DEFAULT_BASE_URL = `${VITE_BASE_HOST || 'https://be-paris-backend-cl-ms-api-dev.ccom-stg.paris.cl'}`;
const DEFAULT_PAYMENT_METHODS_BASE_URL = `${VITE_MS_PAYMENTS_METHODS_BASE_URL || 'https://be-paris-backend-billing-dev.ecomm-stg.cencosud.com/api/v1'}`;

const CART_URL = `${DEFAULT_BASE_URL}/carts`;
const AVAILABLE_PAYMENTS_URL = `${DEFAULT_PAYMENT_METHODS_BASE_URL}/customer/available-payment-methods`;
const ORDERS_URL = `${DEFAULT_BASE_URL}/orders`;
const GIFTCARD_URL = `${CART_URL}/gift-card`;
const ORDERS_INTENT_URL = `${DEFAULT_BASE_URL}/orders/intent`;
const ORDER_INTENT_CONFIRM_URL = `${DEFAULT_BASE_URL}/orders/intent/confirm`;
const INVOICE_URL = `${CART_URL}/billing-address`;
const CLUB_PARIS_URL = `${CART_URL}/club-paris-code`;
const CMEDIA_PURCHASE_URL = `${VITE_BFF_BROWSER_BASE_URL}/cmedia/event/purchases`;

// wedding
const WEDDING_ORDERS_URL = `${DEFAULT_BASE_URL}/orders/wedding`;
const WEDDING_ORDERS_INTENT_URL = `${DEFAULT_BASE_URL}/orders/wedding/:idWedding/intent`;
const WEDDING_ORDERS_INTENT_CONFIRM_URL = `${DEFAULT_BASE_URL}/orders/wedding/:idWedding/intent/confirm`;

const BASE_BFF_URL = VITE_BASE_URL_V1 || DEFAULT_BFF_URL;
const SFCC_DOMAIN = 'uat.paris.cl';

//Braze
const VITE_BRAZE_API_KEY = import.meta.env.VITE_BRAZE_API_KEY;
const VITE_BRAZE_ENDPOINT = import.meta.env.VITE_BRAZE_ENDPOINT;

// Home URL based on environment
const getHomeUrl = (): string => {
  switch (VITE_BASE_ENVIRONMENT) {
    case 'DEV':
      return 'https://development.ccom-stg.paris.cl/home';
    case 'STG':
      return 'https://staging.ccom-stg.paris.cl/home';
    case 'PRD':
      return 'https://www.paris.cl/home';
    default:
      return 'https://www.paris.cl/home';
  }
};

const HOME_URL = getHomeUrl();

export const environment = {
  SCOTIABANK_URL,
  ENV_BASE_URL: '',
  BASE_BFF_URL,
  SFCC_DOMAIN,
  GTM_ID,
  deployTarget: 'development',
  AVAILABLE_PAYMENTS_URL: AVAILABLE_PAYMENTS_URL,
  GIFTCARD_URL,
  CLUB_PARIS_URL,
  CREATE_NEW_ORDER: ORDERS_URL,
  CREATE_NEW_ORDER_INTENT: ORDERS_INTENT_URL,
  CONFIRM_ORDER_INTENT: ORDER_INTENT_CONFIRM_URL,
  CREATE_NEW_WEDDING_ORDER: WEDDING_ORDERS_URL,
  CREATE_NEW_WEDDING_ORDER_INTENT: WEDDING_ORDERS_INTENT_URL,
  CONFIRM_WEDDING_ORDER_INTENT: WEDDING_ORDERS_INTENT_CONFIRM_URL,
  GET_ORDER_ID: ORDERS_URL,
  INVOICE_URL,
  CMEDIA_PURCHASE_URL,
  VITE_BRAZE_API_KEY,
  VITE_BRAZE_ENDPOINT,
  HOME_URL
};

export default environment;
